import { Breadcrumbs } from '@/lib';
import { BlogCard } from '@/components/BlogCard';
import { useRouter } from 'next/router';
import styles from './BlogPage.module.scss';
import { Title } from '@/lib';
import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';
import { fetchData } from '@/services/fetchData';

const BlogPage = ({ posts }) => {
  const { push } = useRouter();
  const headerBlock = posts[0];
  const { isTablet } = useAdaptiveWidth();

  return (
    <div className="main_container pt-[150px]">
      <Breadcrumbs
        routes={[{ link: '/blog', text: 'Blog' }]}
        className={styles.crumbs}
      />
      <Title>BLOG</Title>
      {!isTablet && (
        <div className={styles.cardHeader} key={headerBlock.id}>
          <div className={styles.cardHeaderInfo}>
            {headerBlock.tags && headerBlock.tags.length > 0 && (
              <span className={styles.cardHeaderTag}>
                {headerBlock.tags[0]}
              </span>
            )}
            <p
              className={styles.cardHeaderTitle}
              onClick={() => push(`/blog/${headerBlock.slug}`)}
            >
              {headerBlock.title}
            </p>
            <p className={styles.cardHeaderDesc}>{headerBlock.subtitle}</p>
          </div>
          <img
            src={headerBlock.image ?? '/webp/empty.webp'}
            alt="media"
            className={styles.cardHeaderImg}
            onClick={() => push(`/blog/${headerBlock.slug}`)}
          />
        </div>
      )}
      <div className={styles.grid}>
        {posts.slice(1, posts.length).map((item) => (
          <BlogCard
            key={item.id}
            image={item.image ?? '/webp/empty.webp'}
            tag={item.tags ? item.tags[0] : ''}
            title={item.title}
            desc={item.subtitle}
            handleClick={() => push(`/blog/${item.slug}`)}
          />
        ))}
      </div>
    </div>
  );
};

export async function getStaticProps() {
  const posts = await fetchData({
    url: '/pages?page_type=post',
  });

  return { props: { posts: posts }, revalidate: 300 };
}

export default BlogPage;
